const initialState = {};

const producers = (state = initialState, action) =>
{
	switch (action.type)
	{
		case 'ADD_PRODUCER':
		{
			const { producer } = action.payload;

			const producerState = { ...state };

			const producerList = Object.values(producerState);

			const producerObj = producerList.find((eachProducer) => eachProducer?.source === 'mic' && producer?.source === 'mic');

			if (producerObj && producerObj !== undefined && Object.keys(producerObj).length > 0)
			{

				delete producerState[producerObj?.id];
			}

			return { ...producerState, [producer.id]: producer };
		}

		case 'REMOVE_PRODUCER':
		{
			const { producerId } = action.payload;
			const newState = { ...state };

			delete newState[producerId];

			return newState;
		}

		case 'SET_PRODUCER_PAUSED':
		{
			const { producerId, originator } = action.payload;
			const producer = state[producerId];

			let newProducer;

			if (originator === 'local')
				newProducer = { ...producer, locallyPaused: true };
			else
				newProducer = { ...producer, remotelyPaused: true };

			return { ...state, [producerId]: newProducer };
		}

		case 'SET_PRODUCER_RESUMED':
		{
			const { producerId, originator } = action.payload;
			const producer = state[producerId];

			let newProducer;

			if (originator === 'local')
				newProducer = { ...producer, locallyPaused: false };
			else
				newProducer = { ...producer, remotelyPaused: false };

			return { ...state, [producerId]: newProducer };
		}

		case 'CLEAR_PRODUCER':
		{
			return initialState;
		}

		case 'SET_PRODUCER_TRACK':
		{
			const { producerId, track } = action.payload;
			const producer = state[producerId];
			const newProducer = { ...producer, track };

			return { ...state, [producerId]: newProducer };
		}

		case 'SET_PRODUCER_SCORE':
		{
			const { producerId, score } = action.payload;

			const producer = state[producerId];

			const newProducer = { ...producer, score };

			return { ...state, [producerId]: newProducer };
		}

		case 'UPDATE_PRODUCER':
		{

			const { producer } = action.payload;

			console.log('updateProducer', producer);
			const updateProducer = state[producer.id];

			return { ...state, [producer.id]: { ...updateProducer, ...producer } };
		}

		default:
			return state;
	}
};

export default producers;
